"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterStyles = exports.useFilterComponentStyles = void 0;
const styles_1 = require("@material-ui/core/styles");
exports.useFilterComponentStyles = (0, styles_1.makeStyles)({
    root: {
        display: 'flex',
        flexDirection: 'column',
        marginRight: 10,
        flex: '1 1 250px',
    },
    labelWrapper: {
        marginLeft: 2,
        width: '100%',
    },
    fieldWrapper: {
        width: '100%',
    },
});
exports.useFilterStyles = (0, styles_1.makeStyles)((theme) => ({
    root: {
        display: 'flex',
    },
    disabled: {
        '& input': {
            backgroundColor: theme.palette.grey[200],
        },
    },
    selectWrapper: {
        width: 150,
        marginRight: 10,
    },
    textWrapper: {
        width: 'calc(100% - 100px)',
    },
    textWithoutSelectWrapper: {
        width: '100%',
    },
}));
//# sourceMappingURL=field-filter-styles.js.map